
(function ($, app, _) {
    "use strict";

    app.SlickSliderSetup = function () {
        $('.bottom-slider-container').slick({
            slidesToShow:3,
            slidesToScroll:1,
            autoplay: true,
            autoplaySpeed: 2000,
            nextArrow:$('.next-slide-news'),
            prevArrow:$('.prev-slide-news'),
            responsive:[
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow:1,
                        slidesToScroll:1,
                        infinite: false,
                        dots:true,
                        arrows:false,
                        draggable:true,
                        autoplay:true,
                        autoplaySpeed:60000
                    }
                }
            ]
        });







    };

    $('.product-standard-slider').slick({
        slidesToShow:1,
        slidesToScroll:1,
        autoplay: true,
        autoplaySpeed: 4000,
        fade: true,
        nextArrow:$('.next-slide'),
        prevArrow:$('.prev-slide'),
    });

    $('.product-slider-premium').slick({
        slidesToShow:1,
        slidesToScroll:1,
        autoplay: true,
        autoplaySpeed: 4000,
        fade: true,
        nextArrow:$('.next-slide'),
        prevArrow:$('.prev-slide'),

    });

    $('.tab-1-slide-container').slick({
        nextArrow:$('.next-slide-tab-1'),
        prevArrow:$('.prev-slide-tab-1'),
        responsive:[
            {
                breakpoint: 991,
                settings:{
                    dots:true
                }
            }
        ]
    });

    $('.tab-2-slide-container').slick({
        nextArrow:$('.next-slide-tab-2'),
        prevArrow:$('.prev-slide-tab-2'),
        responsive:[
            {
                breakpoint: 991,
                settings:{
                    dots:true
                }
            }
        ]
    });

    $('.tab-3-slide-container').slick({
        nextArrow:$('.next-slide-tab-3'),
        prevArrow:$('.prev-slide-tab-3'),
        responsive:[
            {
                breakpoint: 991,
                settings:{
                    dots:true
                }
            }
        ]
    });

    $('.tab-4-slide-container').slick({
        nextArrow:$('.next-slide-tab-4'),
        prevArrow:$('.prev-slide-tab-4'),
        responsive:[
            {
                breakpoint: 991,
                settings:{
                    dots:true
                }
            }
        ]
    });

    $('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
        e.target
        e.relatedTarget
        $('.tab-1-slide-container').slick('setPosition');
        $('.tab-2-slide-container').slick('setPosition');
        $('.tab-3-slide-container').slick('setPosition');
        $('.tab-4-slide-container').slick('setPosition');
    });

    $('.simple-slider-container').slick({
        slidesToShow:3,
        slidesToScroll:1,
        autoplay: true,
        autoplaySpeed: 6000,
        nextArrow:$('.next-slide-simple'),
        prevArrow:$('.prev-slide-simple'),
        responsive:[
            {
                breakpoint: 991,
                settings: {
                    slidesToShow:1,
                    slidesToScroll:1,
                    infinite: false,
                    dots:true,
                    arrows:false,
                    draggable:true,
                    autoplay:true,
                    autoplaySpeed:60000
                }
            }
        ]
    });


})(jQuery, app);